import { render, staticRenderFns } from "./jobinfo.vue?vue&type=template&id=61828546&scoped=true"
import script from "./jobinfo.vue?vue&type=script&lang=js"
export * from "./jobinfo.vue?vue&type=script&lang=js"
import style0 from "./jobinfo.vue?vue&type=style&index=0&id=61828546&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61828546",
  null
  
)

export default component.exports